import { render, staticRenderFns } from "./LeaveRequestDetail.vue?vue&type=template&id=074f2508&"
import script from "./leaveRequestDetail.js?vue&type=script&lang=js&"
export * from "./leaveRequestDetail.js?vue&type=script&lang=js&"
import style0 from "./leaveRequestDetail.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports